import React from "react";
import {
  makeStyles,
  Typography,
  Input,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemText,
  ListItem,
  DialogActions,
} from "@material-ui/core";

import { RemoveCircleOutlined } from "@material-ui/icons";
import { Field, FieldArray } from "formik";
import AddIcon from "@material-ui/icons/AddCircle";
import FMUInputField from "./shared/FormIkMUFormComponent/FMUInputField";
import { getLogo } from "./shared/helpers/helper";
import { tokens } from "../theme/tokens";
const useStyles = makeStyles(
  (theme, data, index, handleSetIndex, setFieldValue) => ({
    dialogContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      rowGap: "20px",
      width: "70%",
      margin: "auto",
      paddingBottom: "20px",
      textAlign: "center",
    },
    dialogHeading: {
      color: "#585858",
      fontSize: "1em",
      fontFamily: tokens.type.family,
      fontWeight: 500,
      textAlign: "center",
    },
    dialogItem: {
      display: "flex",
      columnGap: "25px",
      alignItems: "center",
    },
    dialogDiv: {
      width: "600px",
      height: "320px",
    },
    input: {
      // width: "95%",
      border: `1px solid ${tokens.color.border.default}`,
      borderRadius: "10px",
      height: "40px",
      paddingLeft: "3px",
      "& .MuiInputBase-input": {
        textIndent: "10px",
      },
      backgroundColor: tokens.color.surface.sunken,
    },
    postButton: {
      height: "35px",
      fontSize: ".9em",
      width: "150px",
      color: "white",
      backgroundColor: "rgb(0, 151, 187)",
      fontWeight: "600",
      textTransform: "capitalize",
      border: `1px solid ${tokens.color.brand.primary}`,
      borderRadius: "25px",

      "&:hover": {
        backgroundColor: tokens.color.brand.primary,
        opacity: "0.8",
      },
    },
  }),
);
const logo = getLogo();
function SocialDialog({
  dialogOpen,
  handleDialogClose,
  data,
  arrayName,
  index,
}) {
  const classes = useStyles();
  return (
    <Dialog open={dialogOpen} maxWidth={"lg"} onClose={handleDialogClose}>
      <FieldArray name={arrayName}>
        {({ push, remove }) => (
          <>
            <DialogTitle>
              <h2 className={classes.dialogHeading}>
                Add or update Social Media Links
              </h2>
            </DialogTitle>
            <DialogContent
              className={classes.dialogDiv}
              style={
                data.length > 5
                  ? { overflowY: "auto" }
                  : { overflowY: "hidden" }
              }
            >
              <div className={classes.dialogContainer}>
                <div className={classes.dialogItem}>
                  <img src={logo[0]} alt="Facebook" />{" "}
                  <Field
                    name={`${arrayName}[0].value`}
                    fullwidth={true}
                    disableUnderline={true}
                    className={classes.input}
                    component={FMUInputField}
                  />
                </div>
                <div className={classes.dialogItem}>
                  <img src={logo[1]} alt="TwitterIcon" />{" "}
                  <Field
                    name={`${arrayName}[1].value`}
                    fullwidth={true}
                    disableUnderline={true}
                    className={classes.input}
                    component={FMUInputField}
                  />
                </div>
                <div className={classes.dialogItem}>
                  <img src={logo[2]} alt="InstagramIcon" />{" "}
                  <Field
                    name={`${arrayName}[2].value`}
                    fullwidth={true}
                    disableUnderline={true}
                    className={classes.input}
                    component={FMUInputField}
                  />
                </div>
                <div className={classes.dialogItem}>
                  <img src={logo[3]} alt="LinkedinIcon" />{" "}
                  <Field
                    name={`${arrayName}[3].value`}
                    fullwidth={true}
                    disableUnderline={true}
                    className={classes.input}
                    component={FMUInputField}
                  />
                </div>
                <div
                  className={classes.dialogItem}
                  style={{ position: "relative" }}
                >
                  <img src={logo[4]} alt="WebsiteIcon" />{" "}
                  <Field
                    name={`${arrayName}[4].value`}
                    fullwidth={true}
                    disableUnderline={true}
                    className={classes.input}
                    component={FMUInputField}
                  />
                  <AddIcon
                    style={{
                      position: "absolute",
                      right: -40,
                      color: tokens.color.brand.primaryAction,
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      push({ type: "personal", value: "" });
                    }}
                  />
                </div>
                {data?.map((val, key) => {
                  if (key < 5) return null;
                  else
                    return (
                      <div
                        className={classes.dialogItem}
                        style={{ position: "relative" }}
                      >
                        <img src={logo[4]} alt="WebsiteIcon" />{" "}
                        <Field
                          name={`${arrayName}[${key}].value`}
                          fullwidth={true}
                          disableUnderline={true}
                          className={classes.input}
                          component={FMUInputField}
                        />
                        <RemoveCircleOutlined
                          style={{
                            position: "absolute",
                            right: -40,
                            color: tokens.color.brand.primaryAction,
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            remove(key);
                          }}
                        />
                      </div>
                    );
                })}
              </div>
            </DialogContent>
            <DialogActions style={{ paddingBottom: "14px" }}>
              <Button
                className={classes.postButton}
                onClick={handleDialogClose}
                style={{ marginLeft: "auto", marginRight: "auto" }}
              >
                Update
              </Button>
            </DialogActions>
          </>
        )}
      </FieldArray>
    </Dialog>
  );
}

export default SocialDialog;
